// Balance States

export const GET_CUSTOMER_BALANCE_REQUEST ="GET_CUSTOMER_BALANCE_REQUEST";
export const GET_CUSTOMER_BALANCE_SUCCESS ="GET_CUSTOMER_BALANCE_SUCCESS";
export const GET_CUSTOMER_BALANCE_FAILURE ="GET_CUSTOMER_BALANCE_FAILURE";
export const GET_CUSTOMER_LOGOUT ="GET_CUSTOMER_LOGOUT";